import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

const { carbon } = colorsPalettes;

export const CountryWrapper = styled(FlexRow)`
    align-items: center;
    gap: 4px;
`;

export const CountryNameWrapper = styled.div`
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ItemContainer = styled.div<{ isActive?: boolean }>`
    ${({ isActive }) =>
        isActive
            ? css`
                  background-color: ${carbon[25]};
              `
            : null}

    &:hover {
        background-color: ${carbon[25]};
    }
`;
